// M11 cross-product timeline helpers. The backend decides what the user owns; this only labels and routes.
import { salesVideoProjectPath } from "@/lib/salesVideoStatus";

export const HISTORY_KIND_LABELS = { sales_video: "Video Jualan", shortdrama: "ShortDrama", legacy_video: "Video (lama)" };
const STATUS = {
  completed: "Selesai", failed: "Gagal", draft: "Draft", concept_ready: "Draft", processing: "Diproses", submitted: "Diproses", queued: "Diproses",
  reconciling: "Perlu diperiksa", waiting: "Menunggu", generating: "Diproses", planning: "Diproses", assembling: "Diproses",
};
export const historyKindLabel = (kind) => HISTORY_KIND_LABELS[kind] || "Lainnya";
export const historyStatusLabel = (status) => STATUS[String(status || "").toLowerCase()] || "Status lain";

// Only the Video Jualan project has a deep link; the other products open their own list. Never builds a URL from free text.
export const historyPath = (item) => {
  if (!item || typeof item.id !== "string" || !/^[0-9a-f]{24}$/.test(item.id)) return null;
  if (item.kind === "sales_video") return salesVideoProjectPath(item.id);
  if (item.kind === "shortdrama") return "/shortdrama";
  if (item.kind === "legacy_video") return "/riwayat";
  return null;
};

export const normalizeHistory = (payload) => (Array.isArray(payload?.items) ? payload.items.filter((i) => i && typeof i.id === "string" && typeof i.kind === "string" && typeof i.created_at === "string") : []);
